export const COMPANY_ID_HEADER = 'x-company-id';

export type AuthContext = {
  companyId: string;
  userId: string; // Add userId for future use
};
